import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';
import { Form, Label, TextArea } from 'semantic-ui-react';

import MarkdownHint from 'components/common/MarkdownHint';

import './TextAreaField.css';

class TextAreaField extends Component {
  static propTypes = {
    input: PropTypes.oneOfType([
      PropTypes.object,
    ]).isRequired,
    meta: PropTypes.oneOfType([
      PropTypes.object,
    ]).isRequired,
    type: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    markdown: PropTypes.bool,
    autoHeight: PropTypes.bool,
  };

  static defaultProps = {
    required: false,
    label: null,
    placeholder: null,
    autoHeight: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      charsLeft: props.maxLength,
    };
  };

  componentDidUpdate(prevProps) {
    if (this.props.input.value !== prevProps.input.value) {
      const charsLeft = prevProps.maxLength - this.props.input.value.length;
      this.setState({ charsLeft });
    }
  }

  render() {
    const {
      input,
      label,
      placeholder,
      required,
      maxLength,
      markdown,
      meta: { touched, error },
    } = this.props;

    if (!('id' in input)) {
      input.id = `id_${input.name}`;
    }

    return (
      <Translation>
        {(t) => (
          <div className="text-area-field__component">
            <Form.Field error={Boolean(touched && error)}>
              {label &&
                <label htmlFor={input.id}>{label}</label>
              }

              <TextArea
                {...input}
                placeholder={placeholder}
                label={required ? { icon: 'asterisk' } : null}
                maxLength={this.props.maxLength ? this.props.maxLength : null}
                autoHeight={this.props.autoHeight}
              />

              <div className="hint-block">
                {maxLength &&
                  <div className="maxlength-chars-left">
                    <span>
                      {this.state.charsLeft}&nbsp;
                      {t("characters left")}
                    </span>
                  </div>
                }
                {markdown && <MarkdownHint />}
              </div>

              {touched && error &&
                <Label
                  color={'red'}
                  pointing
                >
                  {error}
                </Label>
              }
            </Form.Field>
          </div>
        )}
      </Translation>
    );
  }
}

export default TextAreaField;
